const checkActivoInitialState = {
  checkActivo: {
    loading: false,
    error: null,
    data: null,
  },
};

export default checkActivoInitialState;
